<template>
  <div>
    <vue-headful title="Accountgegevens" />
    <Header page_title="Accountgegevens" />
    <div class="heading mt-4">
      <div class="max-600">
        <div class="d-flex align-items-center px-4 mx-2">
          <div class="flex-grow-1">
            <h2 class="sd-title mini right-line position-relative">
              <span class="title-text"><svg-icon icon="smiley" />Accountgegevens</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 px-4 mx-2 pb-3">
      <div class="container-fluid p-0 pb-3">
        <NotificationContainer />
        <form method="post" @change="onFormChange" @submit.prevent="onSubmit" class="sd-form">
          <div class="mb-2">
            <div class="upload-photo step block mb-3" v-if="user">
              <div class="">
                <div class="text-center pt-4 mb-1 position-relative">
                  <span v-if="!user.avatar" class="photo-comment">
                    Upload
                    <br />profielfoto
                  </span>
                  <div class="pb-3">
                    <div
                      v-if="user.avatar && !preview_avatar"
                      class="avatar profile position-relative d-block mx-auto overflow-hidden rounded-circle"
                    >
                      <input
                        type="file"
                        ref="avatar"
                        @change="onFileChangeAvatar"
                        class="placeholder"
                      />
                      <div class="image_background" :style="this.ImageBackground(user.avatar)"></div>
                    </div>
                    <div
                      v-if="preview_avatar"
                      class="avatar profile position-relative d-block mx-auto overflow-hidden rounded-circle"
                    >
                      <input
                        type="file"
                        ref="avatar"
                        @change="onFileChangeAvatar"
                        class="placeholder"
                      />
                      <div class="image_background" :style="this.ImageBackground(preview_avatar)"></div>
                    </div>
                    <div
                      v-if="!user.avatar && !preview_avatar"
                      class="icon svg d-block mx-auto position-relative"
                    >
                      <input
                        type="file"
                        ref="avatar"
                        @change="onFileChangeAvatar"
                        class="placeholder"
                      />
                      <svg
                        viewBox="0 0 100 100"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g>
                            <path
                              d="M50,100 C77.6142375,100 100,77.6142375 100,50 C100,22.3857625 77.6142375,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z M50,94.7368421 C25.2925244,94.7368421 5.26315789,74.7074756 5.26315789,50 C5.26315789,25.2925244 25.2925244,5.26315789 50,5.26315789 C74.7074756,5.26315789 94.7368421,25.2925244 94.7368421,50 C94.7368421,74.7074756 74.7074756,94.7368421 50,94.7368421 Z"
                              fill="#625A55"
                              fill-rule="nonzero"
                            />
                            <g transform="translate(22.368421, 22.368421)">
                              <polygon
                                points="0 0 56.5789474 0 56.5789474 56.5789474 0 56.5789474"
                              />
                              <circle
                                fill="#FFCD00"
                                cx="28.2894737"
                                cy="28.2894737"
                                r="7.07236842"
                              />
                              <path
                                d="M47.1491228,9.42982456 L39.6759868,9.42982456 L36.7527412,6.24725877 C35.8804825,5.28070175 34.6074561,4.71491228 33.2872807,4.71491228 L23.2916667,4.71491228 C21.9714912,4.71491228 20.6984649,5.28070175 19.8026316,6.24725877 L16.9029605,9.42982456 L9.42982456,9.42982456 C6.83662281,9.42982456 4.71491228,11.5515351 4.71491228,14.1447368 L4.71491228,42.4342105 C4.71491228,45.0274123 6.83662281,47.1491228 9.42982456,47.1491228 L47.1491228,47.1491228 C49.7423246,47.1491228 51.8640351,45.0274123 51.8640351,42.4342105 L51.8640351,14.1447368 C51.8640351,11.5515351 49.7423246,9.42982456 47.1491228,9.42982456 Z M28.2894737,40.0767544 C21.7828947,40.0767544 16.502193,34.7960526 16.502193,28.2894737 C16.502193,21.7828947 21.7828947,16.502193 28.2894737,16.502193 C34.7960526,16.502193 40.0767544,21.7828947 40.0767544,28.2894737 C40.0767544,34.7960526 34.7960526,40.0767544 28.2894737,40.0767544 Z"
                                fill="#FFCD00"
                                fill-rule="nonzero"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <!-- <p class="mb-0">
                    <strong>{{ user.firstname }}</strong>
                  </p>
                  <p class="mb-0">{{ user.email }}</p> -->
                </div>
              </div>
            </div>
            <div v-if="user" class="input-row">
              <div class="sd-col-6 sd-input">
                <label>Voornaam<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="
                    this.required.includes('firstname') ? 'require' : ''
                  "
                  v-bind:placeholder="
                    'Voornaam' +
                      [this.required.includes('firstname') ? ' *' : '']
                  "
                  v-model="form.firstname"
                  autocomplete="nope"
                  required
                />
              </div>
              <div class="sd-col-6 sd-input">
                <label>Achternaam<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="
                    this.required.includes('lastname') ? 'require' : ''
                  "
                  v-bind:placeholder="
                    'Achternaam' +
                      [this.required.includes('lastname') ? ' *' : '']
                  "
                  v-model="form.lastname"
                  autocomplete="nope"
                  required
                />
              </div>
            </div>
            <div v-if="user" class="input-row">
              <div class="sd-input sd-col-12">
                <label>E-mailadres<span class="required">*</span></label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="E-mailadres"
                  v-model="form.email"
                  autocomplete="nope"
                  required
                />
              </div>
            </div>
            <div class="input-row">
              <div class="sd-input sd-col-12">
                <label>Mobiel nummer<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="
                    this.required.includes('mobile') ? 'require' : ''
                  "
                  v-bind:placeholder="
                    'Mobiel nummer' +
                      [this.required.includes('mobile') ? ' *' : '']
                  "
                  v-model="form.mobile"
                  autocomplete="nope"
                  required
                />
              </div>
            </div>
          </div>
          <div class="mb-3 pb-1">
            <h2 class="sd-title mini right-line mb-20px"><span class="title-text"><svg-icon icon="address" />Adresgegevens</span></h2>
            <!-- <router-link
              v-if="!form.search_lat && !form.search_lng && !user"
              :to="{ name: 'location' }"
              class="btn btn-gray btn-block btn-w-icon"
            >
              Selecteer je adres op de kaart
              <i
                class="material-icons"
              >location_searching</i>
            </router-link>
            <router-link
              v-if="user && !user.search_lat && !user.search_lng"
              :to="{ name: 'location' }"
              class="btn btn-gray btn-block btn-w-icon"
            >
              Klik hier en selecteer je adres op de kaart
              <i
                class="material-icons"
              >location_searching</i>
            </router-link>
            <AddressCard
              v-if="form.search_lat && form.search_lng"
              :address="{
                street: form.street,
                street_number: form.street_number,
                house_addition: form.house_addition,
                postal_code: form.postal_code,
                city: form.city,
                edit: { name: 'location' }
              }"
            />
            <AddressCard
              v-if="user.search_lat && user.search_lng"
              :address="{
                street: user.street,
                street_number: user.street_number,
                house_addition: user.house_addition,
                postal_code: user.postal_code,
                city: user.city,
                edit: { name: 'location' }
              }"
            /> -->
            <div class="input-row">
              <div class="sd-col-6 sd-input">
                <label>Straat<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('street') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'Straat' + [this.required.includes('street') ? ' *' : '']
                  "
                  v-model="form.street"
                  autocomplete="nope"
                />
              </div>
              <div class="sd-col-3 sd-input">
                <label>Nummer<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('street_number') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'Nummer' +
                      [this.required.includes('street_number') ? ' *' : '']
                  "
                  v-model="form.street_number"
                  autocomplete="nope"
                />
              </div>
              <div class="sd-col-3 sd-input">
                <label>Toevoeging</label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:placeholder="'Toevoeging'"
                  v-model="form.house_addition"
                  autocomplete="nope"
                  maxlength="7"
                />
              </div>
            </div>
            <div class="input-row">
              <div class="sd-col-5 sd-input">
                <label>Postcode<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('postal_code') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'Postcode' +
                      [this.required.includes('postal_code') ? ' *' : '']
                  "
                  v-model="form.postal_code"
                  autocomplete="nope"
                />
              </div>
              <div class="sd-col-7 sd-input">
                <label>Plaats<span class="required">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="[
                    this.required.includes('city') ? 'require' : ''
                  ]"
                  v-bind:placeholder="
                    'Plaats' + [this.required.includes('city') ? ' *' : '']
                  "
                  v-model="form.city"
                  autocomplete="nope"
                />
              </div>
            </div>
          </div>
          <Required v-if="user" />
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >{{ this.action == "next" ? "Volgende stap" : "Bewaar" }}</button>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import AddressCard from "@/components/AddressCard.vue";

export default {
  data: function() {
    return {
      user: "",
      form: {
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        password_confirmation: "",
        type: 1,
        mobile: "",
        street: "",
        street_number: "",
        house_addition: "",
        postal_code: "",
        city: "",
        search_lat: "",
        search_lng: "",
        account_name: "",
        account_number: "",
        income_tax: 0,
        avatar: "",
      },
      old_email: "",
      required: "",
      preview_avatar: ""
    };
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      var obj;
      // the user is logged in
      if (localStorage.getItem("user-token")) {
        await this.updateLocalUser();
        
        this.user = JSON.parse(localStorage.getItem("user"));

        // set array required
        this.required = this.$store.state.applicant_fields;

        // remove some form obj properties
        delete this.form["password"];
        delete this.form["password_confirmation"];
        delete this.form["type"];

        // update the form obj from user
        for (obj in this.form) {
          if (this.user[obj]) {
            // user details info match form obj property
            this.form[obj] = this.user[obj]; // update
          }
        }
        this.old_email = JSON.parse(JSON.stringify(this.form.email));
      } else if (localStorage.getItem("user-register")) {
        // the user is NOT YET verified
        delete this.form["avatar"];
        delete this.form["name"];

        const user_register = JSON.parse(localStorage.getItem("user-register"));
        for (obj in user_register) {
          if (user_register[obj] && obj != "type") {
            this.form[obj] = user_register[obj]; // update
          }
        }
        // load the address from form
        const address = JSON.parse(localStorage.getItem("address"));
        if (address) {
          for (obj in address) {
            if (address[obj]) {
              this.form[obj] = address[obj];
            }
          }
        }
      }
    },
    
    onFileChangeAvatar() {
      this.form.avatar = this.$refs.avatar.files[0];
      if (this.$refs.avatar.files[0]) {
        var reader = new FileReader();
        var _this = this;

        reader.onload = function(e) {
          _this.preview_avatar = e.target.result;
        };

        reader.readAsDataURL(this.$refs.avatar.files[0]);
      }
      // this.preview_avatar = URL.createObjectURL(this.form.avatar);
      localStorage.setItem("form-pending", JSON.stringify(true));
      this.$store.state.loading = true;
      this.updateUser()
        .then(e => {
          this.updateLocalUser()
            .then(user => {
              this.user = user;
              this.$store.state.user_avatar = user.avatar
              this.$store.state.loading = false;
            })
            .catch(err => {
              this.$store.state.loading = false;
              this.preview_avatar = "";
            });
        })
        .catch(err => {
          this.$store.state.loading = false;
          this.preview_avatar = "";
        });
    },
    async updateUser() {
      // console.log("async updateUser()");
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        let formData = new FormData();
        for (var obj in this.form) {
          if (obj != "email") {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async updateUserEmail() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/change_email";
        let formData = new FormData();
        formData.append("email", this.form["email"]);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(success => {
            localStorage.setItem("force-notif", JSON.stringify(true));
            const notification = {
              type: "success",
              message: success.data.message
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async geocode() {
      return new Promise(resolve => {
        this.$gmapApiPromiseLazy().then(() => {
          const geocoder = new google.maps.Geocoder();
          var form = this.form;
          const address = this.form.street_number + "+" + this.form.street + "+" + this.form.postal_code + "+" + this.form.city;
  
          geocoder.geocode({ address }, function(results, status) {
            if (status === "OK") {
              const latitude = results[0].geometry.location.lat();
              const longitude = results[0].geometry.location.lng();
              form["search_lat"] = latitude;
              form["search_lng"] = longitude;
              resolve({status:'ok'});
            } else {
              resolve({status:'fail'});
            }
          });
        }).catch(() => {
          resolve({status:'fail'});
        });
      });
    },
    async onSubmit() {
      // console.log("async onSubmit()");
      this.$store.state.loading = true;
      let geo = await this.geocode();
      if (geo.status) {
        if (localStorage.getItem("user-token")) {
          await this.updateUser();
  
          if (this.old_email != this.form.email) {
            await this.updateUserEmail();
          }
  
          await this.updateLocalUser();
          this.user = JSON.parse(localStorage.getItem("user"));
          window.scrollTo(0, 0);
          if (this.action == "next") {
            this.$router.replace({
              name: "applicant-step_1",
              params: { action: "next" }
            });
          } else {
              this.$router.replace({
                name: "applicant-dashboard"
              });
          }
        } else {
          await this.registerUser(this.form);
        }
        this.$store.state.loading = false;
      }
    },
    onFormChange() {
      this.geocode();
      // update the localstorage when form is changing
      var obj;
      const user_register = this.form;
      for (obj in user_register) {
        // remove obj property that is empty
        if (user_register[obj] == "") {
          // delete user_register[obj]; // delete
        }
      }

      localStorage.setItem("form-pending", JSON.stringify(true));
      if (!localStorage.getItem("user-token")) {
        localStorage.setItem("user-register", JSON.stringify(user_register));
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // this.savePending(to, from, next);
    var subpages = ["location"];
    if (subpages.indexOf(to.name) > -1) {
      next();
    } else {
      this.savePending(to, from, next);
    }
  },
  components: {
    AddressCard
  }
};
</script>

<style scoped>
input[type="file"].placeholder {
  border-radius: 100%;
}
form .avatar {
  width: 100px;
  height: 100px;
  border-width: 4px;
  background: none;
}

.document.vog {
  background: #f5f4f4;
  border-radius: 7px;
  height: 120px;
  margin: 0;
}
.document.vog .icon {
  width: auto;
  height: auto;
}
.document.vog .icon i {
  font-size: 41px;
  margin-top: 20px;
  color: #c0bdbb;
}
.document.vog label {
  font-family: "Real Head Pro";
  font-weight: normal;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 20px;
  margin: 0;
}

.custom-checkbox .custom-control-label::before {
  top: 3px;
}
.custom-checkbox .custom-control-label::after {
  top: 3px;
}

i.material-icons-round.toggle-info {
  position: absolute;
  top: 0;
  right: 0;
  color: #FFCD00;
}
i.material-icons-round.toggle-info[aria-expanded="true"] {
  color: #c0bdbb;
}
</style>
